import { Spacing } from 'UI'

export default {
  paper: {
    display: 'flex',
    flexDirection: 'column',
    padding: () => Spacing(5),
    margin: () => Spacing(0, 0, 4, 0)
  },
  switchCurrencyStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0 0 13px 0'
  }
}
